import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { DdiziRecentHistoryType } from './getDdiziRecentHistoryAsync';

export const getDdiziRecentHistoryBulkAsync =
	(rootUrl: string) =>
	async ({ ddiziIds }: { ddiziIds: string[] }) =>
		(
			await posAxiosClient.post<Record<string, DdiziRecentHistoryType>>(
				`${rootUrl}/pos-bff/ddizi/history/recent-bulk`,
				{
					ddiziIds,
				}
			)
		).data;
